const customerAccountVerifiedAt = (data) => {
  return data.verifiedAt || data.phoneVerifiedAt;
};

module.exports = {
  customerAccountVerifiedAt,
};
